import { commonjsGlobal as M } from "./index135.mjs";
import { __module as _ } from "./index172.mjs";
import U from "./index173.mjs";
(function(S) {
  (function(g, p, m) {
    var f = 256, j = 6, $ = 52, C = "random", B = m.pow(f, j), A = m.pow(2, $), D = A * 2, l = f - 1, w;
    function k(r, e, i) {
      var t = [];
      e = e == !0 ? { entropy: !0 } : e || {};
      var n = x(R(
        e.entropy ? [r, v(p)] : r ?? G(),
        3
      ), t), a = new E(t), c = function() {
        for (var u = a.g(j), o = B, s = 0; u < A; )
          u = (u + s) * f, o *= f, s = a.g(1);
        for (; u >= D; )
          u /= 2, o /= 2, s >>>= 1;
        return (u + s) / o;
      };
      return c.int32 = function() {
        return a.g(4) | 0;
      }, c.quick = function() {
        return a.g(4) / 4294967296;
      }, c.double = c, x(v(a.S), p), (e.pass || i || function(u, o, s, d) {
        return d && (d.S && q(d, a), u.state = function() {
          return q(a, {});
        }), s ? (m[C] = u, o) : u;
      })(
        c,
        n,
        "global" in e ? e.global : this == m,
        e.state
      );
    }
    function E(r) {
      var e, i = r.length, t = this, n = 0, a = t.i = t.j = 0, c = t.S = [];
      for (i || (r = [i++]); n < f; )
        c[n] = n++;
      for (n = 0; n < f; n++)
        c[n] = c[a = l & a + r[n % i] + (e = c[n])], c[a] = e;
      (t.g = function(u) {
        for (var o, s = 0, d = t.i, y = t.j, h = t.S; u--; )
          o = h[d = l & d + 1], s = s * f + h[l & (h[d] = h[y = l & y + o]) + (h[y] = o)];
        return t.i = d, t.j = y, s;
      })(f);
    }
    function q(r, e) {
      return e.i = r.i, e.j = r.j, e.S = r.S.slice(), e;
    }
    function R(r, e) {
      var i = [], t = typeof r, n;
      if (e && t == "object")
        for (n in r)
          try {
            i.push(R(r[n], e - 1));
          } catch {
          }
      return i.length ? i : t == "string" ? r : r + "\0";
    }
    function x(r, e) {
      for (var i = r + "", t, n = 0; n < i.length; )
        e[l & n] = l & (t ^= e[l & n] * 19) + i.charCodeAt(n++);
      return v(e);
    }
    function G() {
      try {
        var r;
        return w && (r = w.randomBytes) ? r = r(f) : (r = new Uint8Array(f), (g.crypto || g.msCrypto).getRandomValues(r)), v(r);
      } catch {
        var e = g.navigator, i = e && e.plugins;
        return [+/* @__PURE__ */ new Date(), g, i, g.screen, v(p)];
      }
    }
    function v(r) {
      return String.fromCharCode.apply(0, r);
    }
    if (x(m.random(), p), S.exports) {
      S.exports = k;
      try {
        w = U;
      } catch {
      }
    } else
      m["seed" + C] = k;
  })(
    // global: `self` in browsers (including strict mode and web workers),
    // otherwise `this` in Node and other environments
    typeof self < "u" ? self : M,
    [],
    // pool: entropy pool starts empty
    Math
    // math: package containing random, pow, and seedrandom
  );
})(_);
var H = _.exports;
export {
  H as s
};
